import Image from "next/image";
import Link from "@/components/ui/Link";
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

interface AuthorNameWithImageProps {
  name?: FieldConfig;
  imageUrl?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
}

export default function AuthorNameWithImage({
  name = { hidden: false, value: "", customClass: "" },
  imageUrl = { hidden: false, value: "", customClass: "" },
  slug,
  imageMetadata,
}: AuthorNameWithImageProps) {
  const nameValue = name?.value || "";
  const imageUrlValue = getImageUrl(imageUrl?.value) || "";

  const content = (
    <div className="flex flex-col items-center p-4">
      {/* Avatar */}
      {!imageUrl?.hidden && (
        <div className={`w-20 h-20 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center ${imageUrl?.customClass || ""}`}>
          {imageUrlValue ? (
            <Image
              src={imageUrlValue}
              alt={nameValue}
              width={80}
              height={80}
              className="w-full h-full object-cover"
              style={getFocusPointStyle(imageMetadata)}
              loading="lazy"
              placeholder="blur"
              blurDataURL={BLUR_PLACEHOLDER}
            />
          ) : (
            <svg
              className="w-12 h-12 text-gray-400"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>
          )}
        </div>
      )}

      {/* Author Name */}
      {!name?.hidden && (
        <p className={`mt-3 text-14-tamil-700 text-1B1B1B text-center ${name?.customClass || ""}`}>{nameValue}</p>
      )}
    </div>
  );

  if (slug) {
    return (
      <Link href={`${slug}`} className="block  transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
}
